import { render, staticRenderFns } from "./merchant-setting.vue?vue&type=template&id=10c5b26c&scoped=true"
import script from "./merchant-setting.vue?vue&type=script&lang=js"
export * from "./merchant-setting.vue?vue&type=script&lang=js"
import style0 from "./merchant-setting.vue?vue&type=style&index=0&id=10c5b26c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c5b26c",
  null
  
)

export default component.exports